type CurrencyValue = string | number | null | undefined;

export const formatCurrency = (value: CurrencyValue, locale: string): string =>
  Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
  }).format(Number(value ?? 0) || 0);

export const toMoneyString = (value: CurrencyValue): string =>
  Number(value ?? 0).toFixed(2);
